import { z } from 'zod';

export const isEmail = (email: string): boolean => {
  const result = z.string().email().safeParse(email);
  return result.success;
};
